import Sortable from 'sortablejs'

class Util {
  constructor (options) {
    this.options = Object.assign(
      {
        group: '',
        moveX: false,
        moveY: false,
        moveAll: true,
        delay: 0, // time in milliseconds to define when the sorting should start
        animation: 500, // ms, animation speed moving items when sorting, `0` — without animation
        filter: '.drag__elements--ignore', // Selectors that do not lead to dragging (String or Function)
        ghostClass: 'drag__elements--ghost', // Class name for the drop placeholder
        chosenClass: 'drag__elements--chosen', // Class name for the chosen item
        dragClass: 'drag__elements--dragging' // Class name for the dragging item
      }, options)
  }
  _on (el, event, fn, captureMode = false) {
    if (window.attachEvent) {
      el.attachEvent(event, fn, captureMode)
    } else {
      el.addEventListener(event, fn, captureMode)
    }
  }
  _off (el, event, fn, captureMode = false) {
    if (window.removeEvent) {
      el.removeEvent(event, fn, captureMode)
    } else {
      el.removeEventListener(event, fn, captureMode)
    }
  }
  _toggleClass (el, name, state) {
    if (el) {
      if (el.classList) {
        el.classList[state ? 'add' : 'remove'](name)
      } else {
        var className = (' ' + el.className + ' ').replace(/\s+/g, ' ').replace(' ' + name + ' ', ' ')
        el.className = (className + (state ? ' ' + name : '')).replace(/\s+/g, ' ')
      }
    }
  }
  _css (el, prop, val) {
    var style = el && el.style

    if (style) {
      if (val === void 0) {
        if (document.defaultView && document.defaultView.getComputedStyle) {
          val = document.defaultView.getComputedStyle(el, null)
        } else if (el.currentStyle) {
          val = el.currentStyle
        }

        return prop === void 0 ? val : val[prop]
      } else {
        if (!(prop in style)) {
          prop = '-webkit-' + prop
        }

        // style[prop] = val + (typeof val === 'string' ? '' : 'px')
        style[prop] = val
      }
    }
  }
  _disableDraggable (el) {
    el.draggable = false
  }
  _enableDraggable (el) {
    el.draggable = true
  }
  _clone (el) {
    let Polymer = window.Polymer
    return Polymer && Polymer.dom ? Polymer.dom(el).cloneNode(true) : el.cloneNode(true)
  }
  _index (el, selector) {
    var index = 0

    if (!el || !el.parentNode) {
      return -1
    }

    while (el && (el = el.previousElementSibling)) {
      if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || this._matches(el, selector))) {
        index++
      }
    }

    return index
  }
  _getParentOrHost (el) {
    var parent = el.host

    return (parent && parent.nodeType) ? parent : el.parentNode
  }
  _matches (el, selector) {
    if (el) {
      selector = selector.split('.')

      var tag = selector.shift().toUpperCase()
      var re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g')

      return (
        (tag === '' || el.nodeName.toUpperCase() === tag) &&
    (!selector.length || ((' ' + el.className + ' ').match(re) || []).length === selector.length)
      )
    }

    return false
  }
  _closest (el, selector, ctx) {
    if (el) {
      ctx = ctx || document

      do {
        if ((selector === '>*' && el.parentNode === ctx) || this._matches(el, selector)) {
          return el
        }
        el = this._getParentOrHost(el)
      } while (el)
    }

    return null
  }
  insertAfter (newEl, targetEl) {
    var parentEl = targetEl.parentNode

    if (parentEl.lastChild === targetEl) {
      parentEl.appendChild(newEl)
    } else {
      parentEl.insertBefore(newEl, targetEl.nextSibling)
    }
  }
}

class BindEvent extends Util {
  constructor (options, el) {
    super(options)
    if (!(el && el.nodeType && el.nodeType === 1)) {
      throw new Error('Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el))
    }
    this.el = el
  }
  getOps () {
    return this.options
  }
  setOps (opts) {
    this.options = opts
  }
  _addShadow (evt) {
    const shadow = 8
    const scale = 1.05
    let dragEl = evt.item
    // 设置drag 元素的style
    let dStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`,
      transform: `translate3d(0, 0, 0) scale(${scale})`,
      WebkitTransform: `translate3d(0, 0, 0) scale(${scale})`,
      MozTransform: `translate3d(0, 0, 0) scale(${scale})`,
      MsTransform: `translate3d(0, 0, 0) scale(${scale})`,
      transition: 'all ease-in-out .5s',
      WebkitTransition: 'all ease-in-out .5s',
      MozTransition: 'all ease-in-out .5s',
      MsTransition: 'all ease-in-out .5s',
      opacity: 0.8
    }
    Object.assign(dragEl.style, dStyle)
  }
  _addParentShadow (evt) {
    let parent = evt.target
    const shadow = 8
    let pStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`
    }
    Object.assign(parent.style, pStyle)
  }
  _removeShadow (evt) {
    let parent = evt.target
    const shadow = 0

    let pStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`
    }
    Object.assign(parent.style, pStyle)

    const scale = 1
    let dragEl = evt.item
    // 设置drag 元素的style
    let dStyle = {
      boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`,
      transform: `translate3d(0, 0, 0) scale(${scale})`,
      WebkitTransform: `translate3d(0, 0, 0) scale(${scale})`,
      MozTransform: `translate3d(0, 0, 0) scale(${scale})`,
      MsTransform: `translate3d(0, 0, 0) scale(${scale})`,
      transition: 'all ease-in-out .5s',
      WebkitTransition: 'all ease-in-out .5s',
      MozTransition: 'all ease-in-out .5s',
      MsTransition: 'all ease-in-out .5s',
      opacity: 1
    }
    Object.assign(dragEl.style, dStyle)
  }
  _mouseenter (evt) {
    let sty = document.defaultView.getComputedStyle(evt.target)
    if (!sty['cursor'] || sty['cursor'] !== 'pointer') {
      evt.target.style.cursor = 'move'
    }
    this._toggleClass(evt.target, 'drag__wrap--item--active', true)
  }
  _mouseleave (evt) {
    this._toggleClass(evt.target, 'drag__wrap--item--active', false)
  }
}

let bindEvent

export default {
  name: 'draggAble',
  bind (el, binding, vnode) {
    if (!Sortable) {
      throw new Error('[draggable]: cannot locate Sortable.js.')
    }
    let supportDraggable = false
    supportDraggable = !!('draggable' in document.createElement('div'))
    bindEvent = new BindEvent(binding.value, el)
    let options = bindEvent.getOps()
    /* 设置相关的class及draggable */
    el.classList.add('drag__wrap')
    let children = el.children
    if (supportDraggable) {
      for (let i = 0, len = children.length; i < len; i++) {
        let item = children[i]
        /* 过滤掉不需要移动的子类 */
        if (item.classList.contains(options.filter)) {
          item.classList.add('drag__wrap--item')
          bindEvent._disableDraggable(item)
          bindEvent._css(item, 'opacity', 0.8)
          bindEvent._css(item, 'cursor', 'not-allowed')
        } else {
          item.classList.add('drag__wrap--item')
          bindEvent._enableDraggable(item)
        }
        /* 增加动效 */
        bindEvent._on(item, 'mouseenter', (evt) => {
          bindEvent._mouseenter(evt)
        })
        bindEvent._on(item, 'mouseleave', (evt) => {
          bindEvent._mouseleave(evt)
        })
      }
    } else {
      for (let i = 0, len = children.length; i < len; i++) {
        let item = children[i]
        if (item.classList.contains('drag__elements--ignore')) {
          item.classList.add('drag__wrap--item')
        } else {
          item.classList.add('drag__wrap--item')
        }
      }
    }
  },
  inserted (el, {name, value, oldValue, expression, arg, modifiers}, vnode) {
    let originalData = value && value.originalData ? value.originalData : []
    /* 重组参数 */
    let options = {
      onChoose (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        value && value.onChoose && value.onChoose(params, vnode.context)
      },
      onStart (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._addShadow(evt)
        bindEvent._addParentShadow(evt)
        el.classList.add('drag__container--active')
        value && value.onStart && value.onStart(params, vnode.context)
      },
      onEnd (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        el.classList.remove('drag__container--active')
        params['originalData'] = originalData

        bindEvent._removeShadow(evt)
        value && value.onEnd && value.onEnd(params, vnode.context)
      },
      onAdd (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }

        bindEvent._removeShadow(evt)

        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        params['originalData'] = originalData
        value && value.onAdd && value.onAdd(params, vnode.context)
      },
      onUpdate (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._removeShadow(evt)
        params['originalData'] = originalData
        value && value.onUpdate && value.onUpdate(params, vnode.context)
      },
      onSort (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        const shadow = 0
        const scale = 1
        let dragEl = evt.item
        // 设置drag 元素的style
        let dStyle = {
          boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`,
          transform: `translate3d(0, 0, 0) scale(${scale})`,
          WebkitTransform: `translate3d(0, 0, 0) scale(${scale})`,
          MozTransform: `translate3d(0, 0, 0) scale(${scale})`,
          MsTransform: `translate3d(0, 0, 0) scale(${scale})`,
          transition: 'all ease-in-out .5s',
          WebkitTransition: 'all ease-in-out .5s',
          MozTransition: 'all ease-in-out .5s',
          MsTransition: 'all ease-in-out .5s',
          opacity: 1
        }
        Object.assign(dragEl.style, dStyle)
        params['originalData'] = originalData
        value && value.onSort && value.onSort(params, vnode.context)
      },
      onRemove (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._removeShadow(evt)
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, vnode.context)
      },
      onMove (evt) {
        let params = {
          from: evt.from,
          to: evt.to
        }
        value && value.onMove && value.onMove(params, vnode.context)
      },
      onClone (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        value && value.onClone && value.onClone(params, vnode.context)
      }
    }
    let container = el
    if (el.children[0].tagName === 'SPAN') {
      container = el.children[0]
    }
    let opts = {}

    /* 获取修饰符中的数据 */
    let modifier = modifiers
    let group = {}
    if (modifier && modifier.pull) {
      group.put = !modifier.pull
      group.pull = modifier.pull
      if (!value.group && !value.group.name) {
        throw new Error('[draggable]: sortable need group or group.name')
      }
      group.name = value.group || value.group.name
    }
    if (modifier && modifier.put) {
      group.pull = !modifier.put
      group.put = modifier.put
      if (!value.group && !value.group.name) {
        throw new Error('[draggable]: sortable need group or group.name')
      }
      group.name = value.group || value.group.name
    }

    if (modifier.x || modifier.y) {
      if (modifier.x) {
        options.moveX = true
      }
      if (modifier.y) {
        options.moveY = true
      }
    } else {
      options.moveAll = true
    }

    if (Object.keys(group).length) {
      opts = Object.assign(bindEvent.getOps(), value, options, {
        group: group
      })
    } else {
      opts = Object.assign(bindEvent.getOps(), value, options)
    }
    bindEvent.setOps(opts)
    let sortAble = new Sortable(container, opts)
    el.dataset['draggable'] = sortAble
  },
  update (el, {name, value, oldValue, expression, arg, modifiers}, vnode) {
    let originalData = value && value.originalData ? value.originalData : []
    let container = el
    if (el.children[0].tagName === 'SPAN') {
      container = el.children[0]
    }

    /* 重组参数 */
    let options = {
      onChoose (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        value && value.onChoose && value.onChoose(params, vnode.context)
      },
      onStart (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._addShadow(evt)
        bindEvent._addParentShadow(evt)
        el.classList.add('drag__container--active')
        value && value.onStart && value.onStart(params, vnode.context)
      },
      onEnd (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        el.classList.remove('drag__container--active')
        params['originalData'] = originalData

        bindEvent._removeShadow(evt)
        value && value.onEnd && value.onEnd(params, vnode.context)
      },
      onAdd (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }

        bindEvent._removeShadow(evt)

        if (originalData && originalData.length) {
          let temp = originalData[evt.newIndex]
          originalData[evt.newIndex] = originalData[evt.oldIndex]
          originalData[evt.oldIndex] = temp
        }
        params['originalData'] = originalData
        value && value.onAdd && value.onAdd(params, vnode.context)
      },
      onUpdate (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._removeShadow(evt)
        params['originalData'] = originalData
        value && value.onUpdate && value.onUpdate(params, vnode.context)
      },
      onSort (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        const shadow = 0
        const scale = 1
        let dragEl = evt.item
        // 设置drag 元素的style
        let dStyle = {
          boxShadow: `rgba(0, 0, 0, 0.2) 0 ${shadow}px ${2 * shadow}px 0`,
          transform: `translate3d(0, 0, 0) scale(${scale})`,
          WebkitTransform: `translate3d(0, 0, 0) scale(${scale})`,
          MozTransform: `translate3d(0, 0, 0) scale(${scale})`,
          MsTransform: `translate3d(0, 0, 0) scale(${scale})`,
          transition: 'all ease-in-out .5s',
          WebkitTransition: 'all ease-in-out .5s',
          MozTransition: 'all ease-in-out .5s',
          MsTransition: 'all ease-in-out .5s',
          opacity: 1
        }
        Object.assign(dragEl.style, dStyle)
        params['originalData'] = originalData
        value && value.onSort && value.onSort(params, vnode.context)
      },
      onRemove (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        bindEvent._removeShadow(evt)
        params['originalData'] = originalData
        value && value.onRemove && value.onRemove(params, vnode.context)
      },
      onMove (evt) {
        let params = {
          from: evt.from,
          to: evt.to
        }
        value && value.onMove && value.onMove(params, vnode.context)
      },
      onClone (evt) {
        let params = {
          oldIndex: evt.oldIndex,
          newIndex: evt.newIndex,
          from: evt.from,
          to: evt.to,
          item: evt.item
        }
        value && value.onClone && value.onClone(params, vnode.context)
      }
    }

    let opts = {}
    opts = Object.assign(bindEvent.getOps(), value, options)
    let sortAble = new Sortable(container, opts)
    el.dataset['draggable'] = sortAble
  },
  unbind (el) {
    el.dataset['draggable'] = {}
    let children = el.children
    for (let i = 0, len = children.length; i < len; i++) {
      let item = children[i]
      bindEvent._off(item, 'mouseenter')
      bindEvent._off(item, 'mouseleave')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/drag/drag.js